var isBoostedPerk = function (deal) {
    var _a, _b, _c;
    return !!((_a = deal === null || deal === void 0 ? void 0 : deal.savings) === null || _a === void 0 ? void 0 : _a.userSavings) && !!((_c = (_b = deal === null || deal === void 0 ? void 0 : deal.savings) === null || _b === void 0 ? void 0 : _b.boostedSavings) === null || _c === void 0 ? void 0 : _c.oldSavings);
};
export default isBoostedPerk;
